(function () {
  'use strict';

  var STAR_FILLED = '#FDCB6E';
  var STAR_EMPTY = '#E0E0E0';

  function readData() {
    var el = document.getElementById('KitabooReviewsData');
    if (!el) return { productGid: '', entries: [] };
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return { productGid: '', entries: [] };
    }
  }

  function buildSummaries(entries) {
    var map = {};
    entries.forEach(function (entry) {
      if (!entry.productId) return;
      if (!map[entry.productId]) map[entry.productId] = { total: 0, count: 0 };
      map[entry.productId].total += Number(entry.rating) || 0;
      map[entry.productId].count += 1;
    });
    Object.keys(map).forEach(function (gid) {
      var item = map[gid];
      item.avgRating = item.count > 0 ? item.total / item.count : 0;
    });
    return map;
  }

  function renderStars(container, avgRating, size) {
    if (!container) return;
    var rounded = Math.round(avgRating);
    container.innerHTML = '';
    for (var i = 1; i <= 5; i++) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', String(size || 12));
      svg.setAttribute('height', String(size || 12));
      svg.setAttribute('aria-hidden', 'true');
      var poly = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
      poly.setAttribute('points', '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2');
      poly.setAttribute('fill', i <= rounded ? STAR_FILLED : STAR_EMPTY);
      svg.appendChild(poly);
      container.appendChild(svg);
    }
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  }

  function hydrateCardRatings(summaries) {
    document.querySelectorAll('.kitaboo-card-rating[data-product-gid]').forEach(function (el) {
      var gid = el.getAttribute('data-product-gid');
      var summary = summaries[gid];
      if (!summary || summary.count <= 0) {
        el.hidden = true;
        return;
      }
      el.hidden = false;
      var stars = el.querySelector('.kitaboo-card-rating__stars');
      var avgEl = el.querySelector('.kitaboo-card-rating__avg');
      var countEl = el.querySelector('.kitaboo-card-rating__count');
      renderStars(stars, summary.avgRating, 12);
      if (avgEl) avgEl.textContent = summary.avgRating.toFixed(1);
      if (countEl) countEl.textContent = '(' + summary.count + ')';
    });
  }

  function initPdpRating(summaries, productGid) {
    var ratingEl = document.getElementById('kitaboo-pdp-rating');
    if (!ratingEl || !productGid) return;
    var summary = summaries[productGid];
    if (!summary || summary.count <= 0) return;

    var stars = ratingEl.querySelector('.kitaboo-pdp-rating__stars');
    var avgEl = ratingEl.querySelector('.kitaboo-pdp-rating__avg');
    renderStars(stars, summary.avgRating, 16);
    if (avgEl) avgEl.textContent = summary.avgRating.toFixed(1);
  }

  function renderReviewCarousel(reviews) {
    var carousel = document.getElementById('kitaboo-reviews-carousel');
    var track = document.getElementById('kitaboo-reviews-track');
    var controls = document.getElementById('kitaboo-reviews-controls');
    if (!carousel || !track || !reviews.length) return;

    track.innerHTML = reviews.map(function (review) {
      var initial = (review.reviewerName || '?').charAt(0).toUpperCase();
      var starsHtml = '';
      for (var s = 1; s <= 5; s++) {
        starsHtml += '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="' + (s <= review.rating ? STAR_FILLED : STAR_EMPTY) + '"></polygon></svg>';
      }
      return (
        '<article class="kitaboo-review-card">' +
          '<div class="kitaboo-review-card__header">' +
            '<div class="kitaboo-review-card__avatar" aria-hidden="true">' + escapeHtml(initial) + '</div>' +
            '<div class="kitaboo-review-card__meta">' +
              '<span class="kitaboo-review-card__name">' + escapeHtml(review.reviewerName) + '</span>' +
              '<div class="kitaboo-review-card__stars">' + starsHtml + '</div>' +
            '</div>' +
            (review.createdAt ? '<time class="kitaboo-review-card__date">' + escapeHtml(formatDate(review.createdAt)) + '</time>' : '') +
          '</div>' +
          '<p class="kitaboo-review-card__text">' + escapeHtml(review.reviewText) + '</p>' +
        '</article>'
      );
    }).join('');

    if (controls) controls.hidden = reviews.length <= 1;

    var slideIdx = 0;
    function updateSlide() {
      track.style.transform = 'translateX(-' + slideIdx * 100 + '%)';
      var counter = document.getElementById('kitaboo-reviews-counter');
      if (counter) counter.textContent = (slideIdx + 1) + ' / ' + reviews.length;
      var prev = document.getElementById('kitaboo-reviews-prev');
      var next = document.getElementById('kitaboo-reviews-next');
      if (prev) prev.disabled = slideIdx === 0;
      if (next) next.disabled = slideIdx >= reviews.length - 1;
    }

    var prevBtn = document.getElementById('kitaboo-reviews-prev');
    var nextBtn = document.getElementById('kitaboo-reviews-next');
    if (prevBtn) {
      prevBtn.onclick = function () {
        slideIdx = Math.max(0, slideIdx - 1);
        updateSlide();
      };
    }
    if (nextBtn) {
      nextBtn.onclick = function () {
        slideIdx = Math.min(reviews.length - 1, slideIdx + 1);
        updateSlide();
      };
    }
    updateSlide();
  }

  function initTabs() {
    var tabBtns = document.querySelectorAll('[data-kitaboo-tab]');
    var panels = document.querySelectorAll('[data-kitaboo-panel]');
    if (!tabBtns.length) return;

    function activate(tab) {
      tabBtns.forEach(function (btn) {
        var active = btn.getAttribute('data-kitaboo-tab') === tab;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-kitaboo-panel') === tab;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-kitaboo-tab'));
      });
    });

    document.querySelectorAll('[data-kitaboo-reviews-link], a[href="#bd-reviews"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var reviewTab = document.querySelector('[data-kitaboo-tab="review"]');
        if (!reviewTab) return;
        e.preventDefault();
        activate('review');
        var target = document.getElementById('bd-reviews');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    var data = readData();
    var summaries = buildSummaries(data.entries || []);
    hydrateCardRatings(summaries);

    if (!data.productGid) return;

    initPdpRating(summaries, data.productGid);
    var productReviews = (data.entries || []).filter(function (e) {
      return e.productId === data.productGid;
    });
    renderReviewCarousel(productReviews);
    initTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
